/**
 * InternetAccessControl Style01 - On/Off (reuse OnOff pattern)
 */
import type { TraitControlProps } from './types'
import { OnOffStyle01 } from './OnOffStyle01'

export function InternetAccessControlStyle01(props: TraitControlProps) {
  return <OnOffStyle01 {...props} />
}
